import type { QueryClient } from '@tanstack/react-query';
import { treeSetHasItems } from '@/common/queries/itemsTreeSetConsistency';
import { invalidateItemListQueries } from '@/features/items/hooks/invalidateItemListQueries';
import { workIntegrationsQueryKeys } from '@/features/settings/work-integrations/queryKeys';

export const invalidateAfterItemSyncMutation = (queryClient: QueryClient, itemId: number) => {
  invalidateItemListQueries(queryClient, treeSetHasItems([itemId]), [itemId]);
  queryClient.invalidateQueries({
    queryKey: workIntegrationsQueryKeys.itemSyncStatusesPrefix(),
  });
  queryClient.invalidateQueries({
    queryKey: workIntegrationsQueryKeys.workIntegrationItemsPrefix(),
  });
};
